// Opzione di account "canali automatici in Tutte le conversazioni"
// (impostazioni generali): quali caselle API (chatbot, concierge, voice) la
// vista "Tutte le conversazioni" mostra al pari delle altre caselle. Lo
// speculare lato server e' Account#all_conversations_api_channels, usato da
// Conversations::Finder::InboxScope: assente, vuota o con valori sconosciuti
// = nessuna, come prima dell'opzione.
import {
  API_CHANNEL_SUBTYPE,
  isChatbotApiInbox,
  isConciergeApiInbox,
  isVoiceApiInbox,
} from './apiChannelSubtype';

export const ALL_CONVERSATIONS_API_CHANNELS_KEY =
  'all_conversations_api_channels';

// Stesso ordine della pagina delle impostazioni.
export const ALL_CONVERSATIONS_API_CHANNELS = Object.freeze([
  API_CHANNEL_SUBTYPE.CHATBOT,
  API_CHANNEL_SUBTYPE.CONCIERGE,
  API_CHANNEL_SUBTYPE.VOICE,
]);

const INBOX_MATCHERS = {
  [API_CHANNEL_SUBTYPE.CHATBOT]: isChatbotApiInbox,
  [API_CHANNEL_SUBTYPE.CONCIERGE]: isConciergeApiInbox,
  [API_CHANNEL_SUBTYPE.VOICE]: isVoiceApiInbox,
};

export const allConversationsApiChannels = (account = {}) => {
  const value =
    account?.custom_attributes?.[ALL_CONVERSATIONS_API_CHANNELS_KEY];
  if (!Array.isArray(value)) return [];

  const selected = value.map((channel) =>
    String(channel ?? '')
      .trim()
      .toLowerCase()
  );
  return ALL_CONVERSATIONS_API_CHANNELS.filter((channel) =>
    selected.includes(channel)
  );
};

// La casella API compare in "Tutte le conversazioni" per scelta dell'account.
export const isApiInboxInAllConversations = (account, inbox) =>
  allConversationsApiChannels(account).some((channel) =>
    INBOX_MATCHERS[channel](inbox)
  );
